'use client'

import { motion } from 'framer-motion'
import { trackConversion, trackCalendlyClick } from '../../../lib/tracking'

export function ServicesCTA() {
  return (
    <section id="contact" className="relative h-[500px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0 bg-black">
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/gradient-bg.png"
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/workshop.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50" />
      </div>

      <div className="relative z-10 container max-w-7xl mx-auto px-6 flex flex-col justify-center h-full">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl lg:text-[80px] font-normal text-white leading-[1] max-w-[900px] font-gendy mb-8"
        >
          Choose your point of entry.
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="text-white/80 text-xl md:text-2xl font-anuphan mb-10 max-w-[700px]"
        >
          Most clients start with The Blueprint. No long-term commitment. Just clarity on where AI can move the needle fastest.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="flex flex-col sm:flex-row gap-4"
        >
          <button
            onClick={() => {
              trackConversion('lead', 999)
              document.getElementById('blueprint')?.scrollIntoView({ behavior: 'smooth' })
            }}
            className="bg-[#544ae8] border border-[#475065] rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:scale-[1.02] active:scale-[0.98] transition-transform"
          >
            Start with The Blueprint — $999
          </button>
          <a
            href="https://calendly.com/alex-behmn/discovery-call"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCalendlyClick('discovery_call')}
            className="border border-white/30 rounded-[100px] px-10 py-4 text-white text-lg font-anuphan hover:bg-white/10 transition-colors text-center"
          >
            Book a Discovery Call
          </a>
        </motion.div>
      </div>
    </section>
  )
}
